import clsx from 'clsx';
import { HubertBadge } from 'components/HubertUI/HubertBadge/index.tsx';
import AddQuestionLanguage from 'components/Questionsv2/builder/AddQuestionLanguage';
import { CREATE_MODES, ECreateQuestionMode, useQuestionEditorContext } from '../context/create-question.context';
import { setCurrentQuestionLanguage } from 'rtk/LibrarySlice.ts';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';
import { selectQuestionLanguage, selectQuestionMode } from 'rtk/questionEditorSelector';
import { useTemplateId, useTemplateLanguageSettings } from 'hooks/useTemplate';
import { setText, updateLanguage } from 'rtk/Question.Editor.Slice';
import { useTranslation } from 'react-i18next';

const LanguageBadgesBar = () => {
  const { t } = useTranslation('Questionsv2');
  const dispatch = useAppDispatch();
  const templateId = useTemplateId();
  const templateLanguageSettings = useTemplateLanguageSettings(templateId);
  const { questionId } = useQuestionEditorContext();
  const questionLanguage = useAppSelector((state) => selectQuestionLanguage(state, questionId));
  const availableLanguages = useAppSelector((state) => state.questionEditor.byId[questionId].availableLanguages);
  const mode = useAppSelector((state) => selectQuestionMode(state, questionId));

  return (
    <div
      className={clsx(
        'sticky top-0',
        'z-[1]',
        'flex flex-col justify-start gap-4',
        'p-4',
        'bg-card',
        'border',
        'rounded-sm',
        [...CREATE_MODES].includes(mode) ? 'hidden' : '',
      )}
    >
      <div className={clsx('flex flex-wrap gap-2')}>
        {mode === ECreateQuestionMode.InTemplateEdit
          ? templateLanguageSettings?.list.map((templateLanguage) => {
              const languageExists = availableLanguages?.includes(templateLanguage);
              return (
                <HubertBadge
                  key={`create-question-template-available-languages-${templateLanguage}`}
                  variant={
                    languageExists
                      ? questionLanguage === templateLanguage
                        ? 'success-inverse'
                        : 'success'
                      : 'danger-inverse'
                  }
                  className={clsx(languageExists ? 'cursor-pointer' : '')}
                  onClick={() => {
                    if (languageExists) {
                      dispatch(updateLanguage({ questionId, language: templateLanguage }));
                      dispatch(setText({ questionId, language: templateLanguage }));
                      dispatch(
                        setCurrentQuestionLanguage({
                          questionId: questionId,
                          language: templateLanguage,
                        }),
                      );
                    }
                  }}
                >
                  {templateLanguage}
                </HubertBadge>
              );
            })
          : availableLanguages &&
            availableLanguages.map((language) => {
              return (
                <HubertBadge
                  key={`create-question-available-languages-${language}`}
                  variant={language === questionLanguage ? 'default' : 'secondary'}
                  className={clsx('cursor-pointer')}
                  onClick={() => {
                    dispatch(updateLanguage({ questionId, language }));
                    dispatch(setText({ questionId, language }));
                    dispatch(
                      setCurrentQuestionLanguage({
                        questionId,
                        language: language,
                      }),
                    );
                  }}
                >
                  {language}
                </HubertBadge>
              );
            })}

        {availableLanguages ? (
          <AddQuestionLanguage
            questionId={questionId}
            existingLanguages={availableLanguages}
            initialFromLanguage={questionLanguage}
            triggerText={t('addLanguage.triggerText')}
            disabled={false}
          />
        ) : null}
      </div>
    </div>
  );
};

export default LanguageBadgesBar;
